export default "__VITE_ASSET__DLvLr03D__"